import React from 'react'
import {langTranslate} from 'helper/arabic'
import { appPrefix } from 'helper/browserHelper'

const Footer = () => {
    return (
        <>
            <ul className="fs-2 ls-reset flex flex-wrap lh-copy" data-testid="footerForAE">
                <li className="c-neutral-400 fw-500 mr-4 mb-1">{langTranslate('Top Airlines:')}</li>
                <li className="mr-4 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/emirates-airlines.html`}
                        title="Emirates"
                    >
                        {langTranslate('Emirates')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-arabia-airlines.html`}
                        title="Air Arabia"
                    >
                        {langTranslate('Air Arabia')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-india-express-airlines.html`}
                        title="Air India Express"
                    >
                        {langTranslate('Air India Express')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/flydubai-airlines.html`}
                        title="Flydubai"
                    >
                        {langTranslate('Flydubai')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/etihad-airways-airlines.html`}
                        title="Etihad"
                    >
                        {langTranslate('Etihad')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-india-airlines.html`}
                        title="Air India"
                    >
                        {langTranslate('Air India')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/jet-airways-airlines.html`}
                        title="Jet Airways"
                    >
                        {langTranslate('Jet Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/qatar-airways-airlines.html`}
                        title="Qatar Airways"
                    >
                        {langTranslate('Qatar Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/oman-air-airlines.html`}
                        title="Oman Air"
                    >
                        {langTranslate('Oman Air')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/singapore-airlines.html`}
                        title="Singapore Airlines"
                    >
                        {langTranslate('Singapore Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/cathay-pacific-airlines.html`}
                        title="Cathay Pacific"
                    >
                        {langTranslate('Cathay Pacific')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/srilankan-airlines.html`}
                        title="Sri Lankan"
                    >
                        {langTranslate('Sri Lankan')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/gulf-air-airlines.html`}
                        title="Gulf Air"
                    >
                        {langTranslate('Gulf Air')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/british-airways-airlines.html`}
                        title="British Airways"
                    >
                        {langTranslate('British Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/saudi-arabian-air-airlines.html`}
                        title="Saudi Airlines"
                    >
                        {langTranslate('Saudi Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/flynas-airlines.html`}
                        title="Fly Nas"
                    >
                        {langTranslate('Fly Nas')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/air-asia-airlines.html`}
                        title="Air Asia"
                    >
                        {langTranslate('Air Asia')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/kuwait-airways-airlines.html`}
                        title="Kuwait Airways"
                    >
                        {langTranslate('Kuwait Airways')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/middle-east-airlines.html`}
                        title="Middle East Airlines"
                    >
                        {langTranslate('Middle East Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/indigo-airlines.html`}
                        title="Indigo Airlines"
                    >
                        {langTranslate('Indigo Airlines')}
                    </a>
                </li>
            </ul>
            <ul className="fs-2 ls-reset flex flex-wrap lh-copy">
                <li className="c-neutral-400 fw-500 mr-4 mb-1">{langTranslate('Popular Routes:')} </li>
                <li className="mr-4 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-cochin-flights.html`}
                        title="Dubai Cochin flights"
                    >
                        {langTranslate('Dubai Cochin flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-manila-flights.html`}
                        title="Dubai Manila flights"
                    >
                        {langTranslate('Dubai Manila flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-mumbai-flights.html`}
                        title="Dubai Mumbai flights"
                    >
                        {langTranslate('Dubai Mumbai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/cochin-dubai-flights.html`}
                        title="Cochin Dubai flights"
                    >
                        {langTranslate('Cochin Dubai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-kozhikode-flights.html`}
                        title="Dubai Kozhikode flights"
                    >
                        {langTranslate('Dubai Kozhikode flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-trivandrum-flights.html`}
                        title="Dubai Trivandrum flights"
                    >
                        {langTranslate('Dubai Trivandrum flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-new-delhi-flights.html`}
                        title="Dubai New Delhi flights"
                    >
                        {langTranslate('Dubai New Delhi flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-chennai-flights.html`}
                        title="Dubai Chennai/Madras flights"
                    >
                        {langTranslate('Dubai Chennai/Madras flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/sharjah-kozhikode-flights.html`}
                        title="Sharjah Kozhikode flights"
                    >
                        {langTranslate('Sharjah Kozhikode flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/mumbai-dubai-flights.html`}
                        title="Mumbai Dubai flights"
                    >
                        {langTranslate('Mumbai Dubai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-mangalore-flights.html`}
                        title="Dubai Mangalore flights"
                    >
                        {langTranslate('Dubai Mangalore flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dubai-hyderabad-flights.html`}
                        title="Dubai Hyderabad flights"
                    >
                        {langTranslate('Dubai Hyderabad flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/sharjah-trivandrum-flights.html`}
                        title="Sharjah Trivandrum flights"
                    >
                        {langTranslate('Sharjah Trivandrum flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/sharjah-cochin-flights.html`}
                        title="Sharjah Cochin flights"
                    >
                        {langTranslate('Sharjah Cochin flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/trivandrum-dubai-flights.html`}
                        title="Trivandrum Duabi flights"
                    >
                        {langTranslate('Trivandrum Duabi flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-jeddah-flights.html`}
                        title="Riyadh Jeddah flights"
                    >
                        {langTranslate('Riyadh Jeddah flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-riyadh-flights.html`}
                        title="Jeddah Riyadh flights"
                    >
                        {langTranslate('Jeddah Riyadh flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-jeddah-flights.html`}
                        title="Dammam Jeddah flights"
                    >
                        {langTranslate('Dammam Jeddah flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-dubai-flights.html`}
                        title="Riyadh Duabi flights"
                    >
                        {langTranslate('Riyadh Duabi flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-hyderabad-flights.html`}
                        title="Riyadh Hyderabad flights"
                    >
                        {langTranslate('Riyadh Hyderabad flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-dubai-flights.html`}
                        title="Jeddah Dubai flights"
                    >
                        {langTranslate('Jeddah Dubai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-chennai-flights.html`}
                        title="Dammam Chennai flights"
                    >
                        {langTranslate('Dammam Chennai flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/jeddah-dammam-flights.html`}
                        title="Jeddah Dammam flights"
                    >
                        {langTranslate('Jeddah Dammam flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/dammam-riyadh-flights.html`}
                        title="Dammam Riyadh flights"
                    >
                        {langTranslate('Dammam Riyadh flights')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/riyadh-dammam-flights.html`}
                        title="Riyadh Dammam flights"
                    >
                        {langTranslate('Riyadh Dammam flights')}
                    </a>
                </li>
            </ul>
            <ul className="fs-2 ls-reset flex flex-wrap lh-copy">
                <li className="c-neutral-400 fw-500 mr-4 mb-1">{langTranslate('Other Tools:')}</li>
                <li className="mr-4 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/hotels/united-arab-emirates/`}
                        title="Hotels"
                    >
                        {langTranslate('Hotels')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-tickets/cheap-flight-air-tickets-domestic.html`}
                        title="Domestic Air Tickets"
                    >
                        {langTranslate('Domestic Air Tickets')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/flight-schedules-domestic.html`}
                        title="Domestic Flight Schedule"
                    >
                        {langTranslate('Domestic Flight Schedule')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/domestic-airlines.html`}
                        title="Domestic Airlines"
                    >
                        {langTranslate('Domestic Airlines')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/tourism/airports/`}
                        title="Domestic Airports"
                    >
                        {langTranslate('Domestic Airports')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-tickets/cheap-flight-air-tickets-international.html`}
                        title="International Air Tickets"
                    >
                        {langTranslate('International Air Tickets')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/flight-schedules-international.html`}
                        title="International Flight Schedule"
                    >
                        {langTranslate('International Flight Schedule')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/international-airlines.html`}
                        title="International Airlines"
                    >
                        {langTranslate('International Airlines')}
                    </a>{' '}
                </li>
                <li className="mr-3 mb-1">
                    {' '}
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/tourism/airports/international-airports.html`}
                        title="International Airports"
                    >
                        {langTranslate('International Airports')}
                    </a>{' '}
                </li>
            </ul>
        </>
    )
}

export default Footer
